import { render, staticRenderFns } from "./trans-long-data.vue?vue&type=template&id=5efa1500&scoped=true&"
import script from "./trans-long-data.vue?vue&type=script&lang=ts&"
export * from "./trans-long-data.vue?vue&type=script&lang=ts&"
import style0 from "./trans-long-data.vue?vue&type=style&index=0&id=5efa1500&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5efa1500",
  null
  
)

export default component.exports